export default __webpack_public_path__ + "1931c1327c80cf70891c6a5bd0840c3f.png";